import { render, staticRenderFns } from "./WrongModal.vue?vue&type=template&id=b3f8cf4a&scoped=true"
import script from "./WrongModal.vue?vue&type=script&lang=js"
export * from "./WrongModal.vue?vue&type=script&lang=js"
import style0 from "./WrongModal.vue?vue&type=style&index=0&id=b3f8cf4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f8cf4a",
  null
  
)

export default component.exports